// extracted by mini-css-extract-plugin
module.exports = {"outerClass":"HelpControls_outerClass__13DFA","innerClass":"HelpControls_innerClass__DVY7C"};